/* BRT quote delivery: require pickup or shipping and request address only for shipping. */
(function () {
  'use strict';
  function sync(form) {
    var address = form.querySelector('[data-brt-shipping-details]');
    if (!address) return;
    var selected = form.querySelector('input[name="contact[Delivery method]"]:checked');
    var shipping = Boolean(selected && selected.value === 'Shipping');
    address.hidden = !shipping;
    address.disabled = !shipping;
  }
  function syncAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form#BrtHomepageQuoteForm').forEach(sync);
  }
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('input[name="contact[Delivery method]"]')) return;
    var form = target.closest('form#BrtHomepageQuoteForm');
    if (form) sync(form);
  });
  document.addEventListener('shopify:section:load', function (event) { syncAll(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAll(document); });
  } else {
    syncAll(document);
  }
  window.addEventListener('pageshow', function () { syncAll(document); });
}());
